import { defineMessages, useIntl } from 'react-intl';
import { Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const messages = defineMessages({
  backToHome: {
    id: 'Back to home',
    defaultMessage: 'Back to home',
  },
});

const Wrapper = ({ src, alt, href, title, nolink, className }) => {
  const intl = useIntl();

  const content = <Image src={src} alt={alt} />;

  if (nolink) {
    return <span className={className}>{content}</span>;
  }

  return (
    <Link
      className={className}
      to={href || '/'}
      title={title || intl.formatMessage(messages.backToHome)}
    >
      {content}
    </Link>
  );
};

export default Wrapper;
